export default "__VITE_ASSET__DjPeegDp__"